import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectMaterialsPendingOrders({ orders }: { orders: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Đơn đặt hàng đang xử lý</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Xem tất cả</button>
      </div>

      <div className="space-y-4">
        {orders.map((order) => (
          <div key={order.id} className="p-2 rounded-md border border-slate-50 hover:bg-slate-50 transition-colors cursor-pointer group">
             <div className="flex justify-between items-start mb-1.5">
                <span className="text-xs font-normal text-slate-900 group-hover:text-emerald-600 transition-colors">{order.code}</span>
                <span className={cn("text-xs font-normal", order.statusColor)}>{order.status}</span>
             </div>
             <p className="text-xs font-normal text-slate-600 truncate mb-1">{order.name}</p>
             <div className="flex justify-between items-center text-xs font-normal">
                <span className="text-slate-400">SL: {order.qty}</span>
                <span className="text-slate-400">{order.date}</span>
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}
